import { t } from "i18next"
import lodash from "lodash"

export function filterNullValue(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value))
}

export function checkValue(value, renderAlt) {
  if (value) return value
  if (renderAlt) return renderAlt
  return t("unknown")
}

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}

export const extractedFields = (extractedData, index) => {
  if (!extractedData || lodash.isEmpty(extractedData.fields)) return []
  return lodash.get(extractedData.fields, index, [])
}
